import { gql } from '@apollo/client';

export const TERMINE_TERMIN_CREATE = gql`
  mutation CreateTermin($termin: termine_terminCreateInput!) {
    termine_terminCreate(termin: $termin) {
      error {
        message
      }
      result {
        id
        titel
        datum
        beginn
        ende
        standortId
        terminKalenderId
        markierung
        wiederholung
        wiederholungBis
        termineDetails {
          beschreibung
          specials
        }
        image {
          name
          url
          thumbnailUrl
          contentType
        }
      }
    }
  }
`;

export const TERMINE_UPDATE_TERMIN = gql`
  mutation UpdateTermin($termin: termine_terminUpdateInput!) {
    termine_terminUpdate(termin: $termin) {
      error {
        message
      }
      result {
        beginn
        titel
        id
        wiederholung
        wiederholungBis
        datum
        ende
        image {
          contentType
          name
          thumbnailUrl
          url
        }
        markierung
        standortId
        terminKalenderId
        termineDetails {
          beschreibung
          specials
        }
        termine_arbeitszeiten {
          arbeitsbereich {
            id
            markierung
            name
          }
          beginn
          datum
          ende
          id
          mitarbeiter {
            bildUrl
            id
            nachname
            vorname
          }
        }
        termine_schichten {
          beginn
          datum
          ende
          id
          markierung
          name
          termine_arbeitsbereich {
            id
            markierung
            name
          }
          termine_mitarbeiter {
            bildUrl
            id
            nachname
            vorname
          }
        }
      }
    }
  }
`;

export const TERMINE_TERMIN_KALENDER_CREATE = gql`
  mutation CreateTerminKalender($input: termine_terminKalenderCreateInput!) {
    termine_terminKalenderCreate(input: $input) {
      error {
        message
      }
      result {
        id
        idStandort
        kalenderSchluessel
        markierung
        name
      }
    }
  }
`;

export const TERMINE_TERMIN_DELETE = gql`
  mutation DeleteTermin($idTerminDefinitionen: String!) {
    termine_terminDelete(idTerminDefinitionen: $idTerminDefinitionen) {
      error {
        message
        ... on termine_terminDeleteManagerNotFoundError {
          managerId
        }
        ... on termine_terminDeleteTerminDefinitionNotFoundError {
          idTermin
        }
      }
      result {
        terminId
      }
    }
  }
`;

export const TERMINE_ARBEITSZEIT_VERKNUEPFUNG_DELETE = gql`
  mutation DeleteArbeitszeitVerknuepfung(
    $idTerminDefinition: String!
    $idArbeitszeiten: [String!]!
  ) {
    termine_arbeitszeitVerknuepfungDelete(
      idTerminDefinition: $idTerminDefinition
      idArbeitszeiten: $idArbeitszeiten
    ) {
      error {
        message
      }
      result {
        success
      }
    }
  }
`;
export const TERMINE_SCHICHT_VERKNUEPFUNG_DELETE = gql`
  mutation DeleteSchichtVerknuepfung(
    $idSchichten: [String!]!
    $idTerminDefinition: String!
  ) {
    termine_schichtVerknuepfungDelete(
      idSchichten: $idSchichten
      idTerminDefinition: $idTerminDefinition
    ) {
      error {
        message
      }
      result {
        idSchichten
        idTerminDefinition
      }
    }
  }
`;
